<template lang="pug">
div.reg-tea2nd
  .row
    .col-md-12(v-if="error")
      .form-group(style="margin-top:15px")
        .alert.alert-danger(style="margin-bottom:10px") {{error}}
  .row
    .col-md-12.reg-tea2nd-title
      p Bạn có thể dạy các khối lớp nào?
    div.reg-tea2nd-beehive
      BeeHive(:lstItems='grades' @onlstItems="onlstGrades")
    div.reg-tea2nd-beehive-mobile
      BeeHiveMobile(:lstItemsMobile='grades' @onlstItemsMobile="onlstGrades")
  .row
    .col-md-12.reg-tea2nd-title
      p Các môn học bạn có thể giảng dạy?
    div.reg-tea2nd-beehive
      BeeHive(:lstItems='subjects' @onlstItems="onlstSubjects")
    div.reg-tea2nd-beehive-mobile
      BeeHiveMobile(:lstItemsMobile='subjects' @onlstItemsMobile="onlstSubjects")
  .row
    .form-group.custom-form-group
      .col-md-12.reg-tea2nd-title
        p Yêu cầu tạo môn học mới (nếu có)
        selectize(v-model="selected" :settings="settings")
          option(:value="1") Yoga online
          option(:value="2") Erobic
  .row
    .form-group.custom-form-group(:class='errorArray')
      .col-md-12
        p.reg-tea2nd-title Hình ảnh bằng cấp/ chứng chỉ của bạn *
        p.reg-tea2nd-title-upload Vui lòng cung cấp hình ảnh rõ nét, không mờ, không lóa để quá trình xác thực được diễn ra nhanh chóng. Các hình ảnh cần có Ảnh chụp văn bằng/ chứng chỉ có liên quan đến công việc giảng dạy của bạn.
      .col-md-12
        .box-images
          .box-item(v-if="img" v-for="(img, index) in lstImages")
            span.material-icons(@click='removeImg(index)') cancel
            img(:src="img.src")
          .box-item.last 
            input(name='files[]', type='file' multiple @change="previewDegrees" accept="image/x-png,image/jpeg")
            span 
              i.material-icons.list-action add
              strong Tải ảnh lên
  .row
    .col-md-12(v-if="socialType === 1")
      vue-recaptcha(ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="siteKey")
  //- .row
  //-   .col-md-12(v-if="socialType === 1")
  //-     .form-group.custom-form-group(style='position:relative;')
  //-       label.control-label Nhập mã captcha như hình *
  //-       input#captcha.form-control(v-model="captcha" :type='captchaType' required style='padding-right: 40px !important;')
  //-       i.material-icons.reg-tea2nd-icon-password(@click="switchVisibilityCaptcha" v-if="captchaType === 'text'") visibility
  //-       i.material-icons.reg-tea2nd-icon-password(@click="switchVisibilityCaptcha" v-else) visibility_off
  .row
    .col-md-12
      p.reg-tea2nd-context - Tôi hoàn toàn chịu trách nhiệm về các thông tin đã khai báo trên
      p.reg-tea2nd-context - Yêu cầu sau khi được gửi phải được admin phê duyệt
      p.reg-tea2nd-context - Bằng cách chọn "Đăng ký" bạn đồng ý với 
        span Điều khoản sử dụng cho giáo viên
        |  và 
        span Chính sách bảo mật dành cho giáo viên
        |  của chúng tôi.

  .row
    .col-md-12.lo-custom-footer
      div.col-md-6.col-12
        div.text-right
          button.reg-tea2nd-btn-validate.btn(@click='validateRegister') Đăng ký
      div.col-md-6.col-12
        div.text-left
          button.reg-tea2nd-btn-cancel.btn(@click="backLogin") Quay lại

</template>

<script>
import BeeHive from '../Subject/BeeHive'
import BeeHiveMobile from '../Subject/BeeHiveMobile'
import Selectize from 'vue2-selectize'
import firebase from 'firebase'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import store from '../../store'
import S3FileUpload from '../S3FileUpload/S3FileUpload.js'
import VueRecaptcha from 'vue-recaptcha'
import MdNotification from '@/core/components/mdNotification'

export default {
  components: {
    BeeHive,
    BeeHiveMobile,
    Selectize,
    VueRecaptcha,
    MdNotification
  },
  props: {
    grades: Array,
    subjects: Array,
    dataScreen1: Object,
    socialType: Number,
    newParams: Object
  },
  data() {
    return {
      captcha: null,
      error: null,
      errorArray: [],
      captchaType: 'password',
      settings: {
        plugins: ['remove_button'],
        delimiter: ',',
        persist: true,
        maxItems: 10,
        // searchField: ['value'],
        create: function(input) {
          return {
            value: input,
            text: input
          }
        }
      }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
      selected: '',
      lstGraded: [],
      lstSubjected: [],
      lstImages: [],
      countImages: 0,
      pathImages: [],
      degrees: [],
      params: this.newParams,
      loading: false,
      siteKey: '6LcKzP8UAAAAABD2dgNkZ0u5gHRrvfDMZJeNz3a-',
      recaptchaVerified: false,
      front_params: null
    }
  },
  methods: {
    previewDegrees(e) {
      // console.log(e.target.files)
      const files = e.target.files
      if (files) {
        if (this.countImages === 0) this.lstImages = []
        for (var f = 0; f < files.length; f++) {
          this.lstImages.push({'name': files[f].name, 'file': files[f], 'src': URL.createObjectURL(files[f])})
          this.countImages++
        }
      }
      return
    },
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    removeImg(index) {
      this.lstImages.splice(index, 1)
    },
    switchVisibilityCaptcha() {
      this.captchaType = this.captchaType === 'password' ? 'text' : 'password'
    },
    onlstGrades(lstItems) {
      if (lstItems) {
        this.lstGraded = []
        for (var i = 0; i < lstItems.length; i++) {
          if (lstItems[i].selected === true) this.lstGraded.push(lstItems[i])
        }
      }
    },
    onlstSubjects(lstItems) {
      if (lstItems) {
        this.lstSubjected = []
        for (var i = 0; i < lstItems.length; i++) {
          if (lstItems[i].selected === true) this.lstSubjected.push(lstItems[i])
        }
      }
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        // container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
        // onCancel: this.onCancel
      })
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.recaptchaVerified = false
      if (recaptchaToken !== null && recaptchaToken !== '') {
        this.recaptchaVerified = true
      }
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    validateRegister() {
      // console.log('dataScreen1: ', this.dataScreen1)
      if (this.dataScreen1) {
        const user = {
          email: this.dataScreen1.email,
          password: this.dataScreen1.password
        }
        console.log(this.lstImages, typeof this.lstImages)
        if (this.socialType === 1) {
          if (this.lstGraded.length === 0) {
            this.showNotification('Vui lòng chọn khối lớp bạn có thể giảng dạy', 'warning', 'top', 'right', 2000)
            this.error = 'Vui lòng chọn Khối lớp bạn có thể giảng dạy.'
          } else if (this.lstSubjected.length === 0) {
            this.showNotification('Vui lòng chọn môn học bạn có thể giảng dạy', 'warning', 'top', 'right', 2000)
            this.error = 'Vui lòng chọn Môn học bạn có thể giảng dạy.'
          } else if (this.lstImages.length === 0) {
            this.showNotification('Vui lòng upload bằng cấp của bạn', 'warning', 'top', 'right', 2000)
            this.error = 'Vui lòng upload bằng cấp của bạn.'
          } else if (!this.recaptchaVerified) {
            this.showNotification('Vui lòng nhập Captcha', 'warning', 'top', 'right', 2000)
            this.error = 'Vui lòng nhập Captcha.'
          } else {
            this.show()
            this.$store.dispatch('signUpAction', user)
            .then((res) => {
              // console.log('create user: ')
              // create user
              this.$apollo.mutate({
                mutation: gql(graphql.CREATE_USER),
                variables: {
                  users: [{
                    fullname: this.dataScreen1.fullname,
                    username: this.dataScreen1.username,
                    email: this.dataScreen1.email,
                    phone_number: this.dataScreen1.phone_number,
                    type_user: 2,
                    birthday: this.dataScreen1.birthday,
                    school_id: this.dataScreen1.school_id,
                    social_type: this.socialType,
                    role: 'teacher',
                    require_subject: this.selected.length > 0 ? '{' + this.selected.join() + '}' : null
                  }]
                },
                update: (store, { data: { insert_users } }) => {
                  if (insert_users.affected_rows) {
                    let returning = insert_users.returning
                    if (this.lstImages && this.lstImages.length > 0) this.updateRegisterUploadImg(returning.id)
                  }
                }
              }).then(data => {
                // tao khoi lop giao vien co the giang day
                for (var i = 0; i < this.lstGraded.length; i++) {
                  this.$apollo.mutate({
                    mutation: gql(graphql.CREATE_USER_GRADE),
                    variables: {
                      grades: [{
                        user_id: res.user.uid,
                        grade_id: this.lstGraded[i].id
                      }]
                    },
                    error(error) {
                      if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                        this.$router.go(0)
                      }
                    }
                  })
                }
                // tao mon hoc the manh va mon hoc giang day
                for (var s = 0; s < this.lstSubjected.length; s++) {
                  this.$apollo.mutate({
                    mutation: gql(graphql.CREATE_USER_SUBJECT),
                    variables: {
                      subjects: [{
                        user_id: res.user.uid,
                        subject_id: this.lstSubjected[s].id,
                        status: 2
                      }]
                    },
                    error(error) {
                      if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                        this.$router.go(0)
                      }
                    }
                  })
                }
              }).then(data => {
                // gui verify email cho user
                var user = firebase.auth().currentUser
                // console.log('sendEmailVerification: ', user)
                user.sendEmailVerification()
                .then(function () {
                  console.log('sendMailVerify')
                })
                .catch((error) => {
                  this.loader.hide()
                  console.error(error)
                })
                // hide loading
                this.loader.hide()
                // chuyen trang login
                this.$store.dispatch('signOutAction')
                this.$router.push({name: 'Login', params: {register_reload: true}})
              }).catch((error) => {
                // this.deleteProfile()
                this.loader.hide()
                this.error = error
                console.error(error.message)
              })
            }).catch((error) => {
              if (error.code === 'auth/argument-error') {
                this.showNotification('Mật khẩu không được để trống', 'warning', 'top', 'right', 2000)
                this.error = 'Mật khẩu không được để trống.'
              } else if (error.code === 'auth/invalid-email') {
                this.showNotification('Địa chỉ email không hợp lệ', 'warning', 'top', 'right', 2000)
                this.error = 'Địa chỉ email không hợp lệ.'
              } else if (error.code === 'auth/weak-password') {
                this.showNotification('Mật khẩu phải có ít nhất 6 kí tự', 'warning', 'top', 'right', 2000)
                this.error = 'Mật khẩu phải có ít nhất 6 kí tự.'
              } else if (error.code === 'auth/email-already-in-use') {
                this.showNotification('Địa chỉ email đã tồn tại', 'warning', 'top', 'right', 2000)
                this.error = 'Địa chỉ email đã tồn tại.'
              } else {
                console.error('dang ky 2: ', error.message)
                this.error = error
              }
              this.loader.hide()
            })
          }
        } else if (this.socialType === 2) {
          console.log('ĐĂNG KÝ ACCOUNT GIAO VIÊN BẰNG GOOGLE')
          this.show()
          this.$apollo.mutate({
            mutation: gql(graphql.CREATE_USER),
            variables: {
              users: [{
                fullname: this.dataScreen1.fullname,
                username: this.dataScreen1.email,
                email: this.dataScreen1.email,
                phone_number: this.dataScreen1.phone_number,
                type_user: 2,
                birthday: this.dataScreen1.birthday,
                school_id: this.dataScreen1.school_id,
                social_type: this.socialType,
                avatar: this.dataScreen1.avatar,
                is_activated: true,
                role: 'teacher'
              }]
            },
            update: (store, { data: { insert_users } }) => {
              if (insert_users.affected_rows) {
                let returning = insert_users.returning
                if (this.lstImages && this.lstImages.length > 0) this.updateRegisterUploadImg(returning.id)
              }
            }
          }).then(data => {
            for (var i = 0; i < this.lstGraded.length; i++) {
              this.$apollo.mutate({
                mutation: gql(graphql.CREATE_USER_GRADE),
                variables: {
                  grades: [{
                    user_id: this.$store.getters.user,
                    grade_id: this.lstGraded[i].id
                  }]
                }
              })
            }
            for (var s = 0; s < this.lstSubjected.length; s++) {
              this.$apollo.mutate({
                mutation: gql(graphql.CREATE_USER_SUBJECT),
                variables: {
                  subjects: [{
                    user_id: this.$store.getters.user,
                    subject_id: this.lstSubjected[s].id
                  }]
                }
              })
            }
          }).then(data => {
            // debugger
            this.loader.hide()
            this.$store.commit('setIsHomePage', false)
            if (this.front_params && this.front_params.name !== null) {
              this.$store.commit('setIsHomePage', true)
              this.$mycontroller.redirectToPageBeforeLogin(this.front_params)
            } else {
              store.commit('setIsLoggedIn', true)
              this.$router.push({name: 'Account', params: {register_reload: true}})
            }
          }).catch((error) => {
            this.loader.hide()
            this.error = error
          })
        }
      }
    },
    async deleteProfile () {
      let db = firebase.firestore()
      let ref = db.collection('users')
      let user = await ref.where('user_id', '==', firebase.auth().currentUser.uid).get()
      await user.ref.delete()
      await firebase.auth().currentUser.delete()
    },
    backLogin() {
      if (this.socialType === 2) {
        this.$store.dispatch('signOutAction')
        this.$store.commit('setIsLoggedIn', false)
        this.$store.commit('setIsHomePage', false)
        if (this.front_params && this.front_params.name !== null) {
          this.$store.commit('setIsHomePage', true)
          let params = this.front_params
          let name = params.name
          this.$delete(params, 'name')
          this.$router.push({name: name, params: params})
        } else this.$router.push('login')
      } else if (this.socialType === 1) {
        this.lstGraded = []
        this.lstSubjected = []
        for (let i = 0; i < this.grades.length; i++) this.grades[i].selected = false
        for (let i = 0; i < this.subjects.length; i++) this.subjects[i].selected = false
        this.$emit('backTeacher1', this.dataScreen1)
      }
    },
    async updateRegisterUploadImg($id) {
      let directory = 'images/degrees'
      let config = S3FileUpload.computed.config(directory)
      let S3Client = new S3FileUpload.computed.S3Client(config)

      if (this.lstImages.length > 0) {
        for (let index = 0; index < this.lstImages.length; index++) {
          let icon = this.lstImages[index]
          let file = icon.file
          let fileName = icon.name.split('.')[0].replace(/ /g, '')
          let random = Math.random().toString().slice(2)
          let fieldName = `${random}_${fileName}`
          await S3Client.uploadFile(file, fieldName).then((data) => {
            this.pathImages.push(data.location)
          })
        }
      }
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_USER_DEGREES),
        variables: {
          uid: $id,
          degrees: this.pathImages.length > 0 ? '{' + this.pathImages.join() + '}' : null
        }
      })
    }
  },
  created () {
    if (this.$route.params.front_top !== undefined) {
      this.front_params = this.$route.params
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-reg-tea2nd-button: #FFD311;
}

.selectize-input {
  min-height: 48px !important;
  line-height: 35px !important;
  border-radius: 10px;
}
.selectize-control.multi .selectize-input.has-items {
  // padding: 0 ;
  div {
    padding-top: 0;
    padding-bottom: 0;
    margin: 0 7px 0px 0 !important;
    background: #FFD311;
    color: #23180A;
    border-radius: 0;
    line-height: 25px !important;
  }
}
.selectize-control.plugin-remove_button [data-value] .remove {
  font-weight: normal;
  font-size: 25px;
}
.reg-tea2nd-title {
  margin: 15px 0 0;
  color: #4B2D15;
  font-weight: bold;
}
.reg-tea2nd-title-upload {
  // font-size: 13px;
  color: #9B9B9B;
}
.reg-tea2nd-icon-password {
  margin-top: -43px; 
  display:block;
  position:absolute;
  right:10px;
  padding:auto 5px;
  &:hover {
    cursor: pointer;
  }
}
.reg-tea2nd {
  .reg-tea2nd-beehive-mobile {display: none;}
  .reg-tea2nd-captcha {
    width: 250px;
    height: auto;
    padding: 10px 0 10px;
  }
  .box-images { 
    margin: 10px 0 5px 0;
    strong span {
      color:#969FAD !important;
      font-weight: normal !important; 
    }
  }
  .box-item {
    float:left;
    width: 122px;
    height: 122px; 
    margin-right: 15px;
    margin-bottom: 15px;
    display:table;
    position: relative;
    &:nth-child(4n) {margin-right: 0;}
    img {
      max-width: 100%; 
      height: 122px;
      border-radius: 3px;
    }
    span {
      position: absolute; 
      right: 5px; 
      top: 5px;
      cursor: pointer;
    }
  }
  .box-item.last {
    margin-right: 0 !important; 
    background: #EAEAEA 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #EAEAEA;
    border-radius: 3px;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    line-height: 122px; 
    cursor: pointer;
    span {
      // display:block; 
      text-align:center; 
      display: inline-block;
      vertical-align: middle;
      line-height: normal; 
      position:relative; 
      top: auto; 
      right: auto;
    }
    strong {
      display:block; 
      text-align:center;
    }
  }
}

.reg-tea2nd-context {
  color: #9B9B9B;
  font-size: 14px;
  margin: 0;
  span {
    color: #1A0DAB;
  }
}
.reg-tea2nd-btn-validate {
  background: var(--color-reg-tea2nd-button);
  color:black;
  text-transform: none;
  font-size: 13px;
  border: 1px solid var(--color-reg-tea2nd-button);
  border-radius: 5px;
  // box-shadow: 0px 0px 0px;
  width: 160px;
  margin-bottom: 20px;
  &:hover {
    color: black;
    background: var(--color-reg-tea2nd-button);
  }
}
.reg-tea2nd-btn-cancel {
  background: white;
  color: black;
  text-transform: none;
  font-size: 13px;
  border: 1px solid var(--color-reg-tea2nd-button);
  border-radius: 5px;
  // box-shadow: 0px 0px 0px;
  width: 160px;
  &:hover {
    color: black;
    background: white;
  }
}
@media (max-width: 991px) {
  .lo-custom-footer{text-align: center;
    .col-12{display: inline-block;
      .reg-tea2nd-btn-validate{float: none; margin-bottom:15px; margin-left: 0;}
      .reg-tea2nd-btn-cancel{float: none;  margin-bottom:15px; margin-right: 0;}
    }
  }
}

// cellphones
@media (max-width: 414px) {
  .reg-tea2nd {
    .reg-tea2nd-beehive {
      display: none;
    }
    .reg-tea2nd-beehive-mobile {
      display: block;
    }
    .box-item {
      float:left;
      width: 149px;
      height: 149px; 
      margin-bottom: 8px;
      margin-right: 16px;
      display: table;
      position: relative;
      &:nth-child(2n) {margin-right: 0;}
      img {
        max-width: 100%; 
        height: 130px;
        border-radius: 3px;
      }
      span {
        position: absolute; 
        right: 5px; 
        top: 5px;
        cursor: pointer;
      }
    }
    .box-item.last {
      line-height: 149px;
    }
    .reg-tea2nd-btn-validate {
      float: left;
      width: 115px !important;
    }
    .reg-tea2nd-btn-cancel {
      float: right;
      width: 115px !important;
    }
  }
}
@media (max-width: 375px) {
  .box-item {
    width: 141px !important;
    height: 141px !important;
    margin-right: 13px !important;
    &:nth-child(2n) {margin-right: 0 !important;}
  }
  .box-item.last {
    line-height: 141px !important;
  }
}
</style>



// WEBPACK FOOTER //
// itemRegisterTeacher2.vue?590c56a2